import { default as Modal } from 'antd/es/modal';

import { triggerDownload } from 'utils/download';

import type { AuthScheme } from 'api';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import {
  EXPORT_KEY_CANCEL_TEST_ID,
  EXPORT_KEY_CONFIRM_TEST_ID,
  EXPORT_KEY_MODAL_TEST_ID,
  EXPORT_LABEL,
  EXPORT_MODAL_WIDTH
} from './constants';
import { PemViewer } from './PemViewer';
import { exportFilename, exportModalTitle, exportPanelLabel } from './utils';

type ExportKeyModalProps = {
  authenticationKey: AuthScheme;
  open: boolean;
  onClose: () => void;
};

export const ExportKeyModal = ({
  authenticationKey,
  open,
  onClose
}: ExportKeyModalProps) => {
  const certificate = authenticationKey.certificate ?? '';

  const onExport = () =>
    triggerDownload(
      new Blob([certificate], { type: 'application/x-pem-file' }),
      exportFilename(authenticationKey)
    );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={EXPORT_MODAL_WIDTH}
      destroyOnHidden
      title={
        <div className="text-lg font-medium text-content-primary">
          {exportModalTitle(authenticationKey.type)}
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <SecondaryButton
            data-testid={EXPORT_KEY_CANCEL_TEST_ID}
            onClick={onClose}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton
            data-testid={EXPORT_KEY_CONFIRM_TEST_ID}
            onClick={onExport}
          >
            {EXPORT_LABEL}
          </PrimaryButton>
        </div>
      }
    >
      <div data-testid={EXPORT_KEY_MODAL_TEST_ID}>
        <PemViewer
          label={exportPanelLabel(authenticationKey.type)}
          content={certificate}
        />
      </div>
    </Modal>
  );
};
